export default __webpack_public_path__ + "static/thumb-landscape-4cd43f74125b17fa1f174bca00e8dff0.jpg";